module.exports = __webpack_public_path__ + "static/media/background_desktop1.939d22bc.png";